import {
  API_URL,
  CHARGEBEE_SITE,
  FORMS_URL,
  LOGIN_REDIRECT_URL_FN,
} from '@dss-libs/shared/utility/global-injection-tokens';
import { environment } from '../../environments/environment';
import { Provider } from '@angular/core';

export function provideEnvironment(): Provider[] {
  return [
    {
      provide: API_URL,
      useValue: environment.apiUrl,
    },
    {
      provide: CHARGEBEE_SITE,
      useValue: environment.chargebeeSite,
    },
    {
      provide: FORMS_URL,
      useValue: environment.formsUrl,
    },
    {
      provide: LOGIN_REDIRECT_URL_FN,
      useValue: () => '/orders',
    },
  ];
}
